import { Component } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { routes } from './app.routes';
import { CommonModule } from '@angular/common';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { DrawingStreamPopoverComponent } from './shared/drawing-stream-popover.component';
import { UserProfileDropdownComponent } from './shared/user-profile-dropdown.component';
import { ThemeService } from './shared/theme.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterModule, CommonModule, DrawingStreamPopoverComponent, UserProfileDropdownComponent, MatIconModule, MatButtonModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'mod-ui';

  menuRoutes = routes.filter(route => route.title);

  showStreamPopover = false;

  constructor(
    public authService: AuthService, 
    private router: Router,
    private themeService: ThemeService
  ) {
    // Initialize theme service
    // this.authService.handleAuthCallback();
  }

  login(): void {
    this.router.navigate(['/login']);
  }

  toggleStreamPopover(): void {
    this.showStreamPopover = !this.showStreamPopover;
  }

  closeStreamPopover(): void {
    this.showStreamPopover = false;
  }
}
